<!--LIGNE SÉPARATRICE EN DÉGRADER DE CHAQUE COTÉ-->
<template>
    <div class="s-line">

        <div class="row justify-content-center">
            <div class="b-col line1"></div>
        </div>
                        
    </div>
</template>

<script>

export default{
    name: "s-line",
    data() {
        return {
        
        }
    }
}

</script>

<style lang="scss" scoped>

</style>